<nav class="d-flex flex-wrap navbar navbar-expand-lg navbar-light justify-content-between">
  <img [src]="logoEquipe" height="10%" width="10%" style="margin-left: 3%">
  <img [src]="logoWorldline" height="20%" width="20%" style="margin-right: 3%">
</nav>
<div class="d-flex flex-wrap flex-row justify-content-center align-items-center">
  @for (feature of mainFeatures; track feature) {
    <div class="cardbox" *kaHasRoles="[feature.role]; checkRealm: true">
      <div class="card mb-3 card-button">
        <a class="card-body d-flex flex-column align-items-center justify-content-center" type="button"
          [routerLink]="feature.route">
          <img class="d-flex flex-wrap align-self-center" [src]="chemimagecard + feature.label + '.png'">
          <h4 class="card-title">{{ `menu-${feature.label.replace(' ', '-').toLowerCase()}` | translate }}</h4>
        </a>
      </div>
    </div>
  }
</div>